console.log('COMPLEMENTARY PRODUCTS LOADED');

class ComplementaryProducts {

  constructor(container) {

    this.container = container;

    this.buttons = [
      ...container.querySelectorAll(
        '[data-complementary-atc]'
      )
    ];

    this.init();

  }

  /* =====================================================
     INIT
  ===================================================== */

  init() {

    this.bindButtons();

  }

  /* =====================================================
     BUTTON EVENTS
  ===================================================== */

  bindButtons() {

    this.buttons.forEach((button) => {

      button.addEventListener(
        'click',
        (event) => {

          event.preventDefault();
          event.stopPropagation();

          this.handleAddToCart(button);

        }
      );

    });

  }

  /* =====================================================
     ADD TO CART
  ===================================================== */

  async handleAddToCart(button) {

    const variantId =
      parseInt(button.dataset.variantId);

    if (!variantId) return;

    try {

      this.setLoading(button, true);

      const response = await fetch(
        '/cart/add.js',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({

            items: [
              {
                id: variantId,
                quantity: 1
              }
            ],

            sections: document.querySelector(
              'cart-items-component'
            )?.dataset.sectionId

          })
        }
      );

      if (!response.ok) {

        throw new Error(
          'Failed to add product'
        );

      }

      const data = await response.json();

      /* =========================================
         FETCH UPDATED CART
      ========================================= */

      const cartResponse = await fetch(
        '/cart.js'
      );

      const cart = await cartResponse.json();

      /* =========================================
         DISPATCH HORIZON EVENT
      ========================================= */

      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cart,
            sourceId: 'complementary-products',
            data: {
              source: 'product-form-component',
              itemCount: 1,
              sections: data.sections
            }
          }
        })
      );

      /* =========================================
         OPEN CART DRAWER
      ========================================= */

      const cartDrawer = document.querySelector(
        'cart-drawer-component'
      );

      cartDrawer?.open?.();

      /* =========================================
         SUCCESS STATE
      ========================================= */

      this.showSuccess(button);

    } catch (error) {

      console.error(error);

      this.showError(button);

    } finally {

      setTimeout(() => {

        this.setLoading(button, false);

      }, 2000);

    }

  }

  /* =====================================================
     LOADING
  ===================================================== */

  setLoading(button, loading) {

    if (loading) {

      button.disabled = true;

      button.innerHTML = 'ADDING...';

    } else {

      button.disabled = false;

      button.innerHTML = 'ADD TO CART';

    }

  }

  /* =====================================================
     SUCCESS
  ===================================================== */

  showSuccess(button) {

    button.innerHTML = 'ADDED';

    button.classList.add(
      'is-added'
    );

    setTimeout(() => {

      button.classList.remove(
        'is-added'
      );

    }, 2000);

  }

  /* =====================================================
     ERROR
  ===================================================== */

  showError(button) {

    button.innerHTML = 'ERROR';

    button.classList.add(
      'is-error'
    );

    setTimeout(() => {

      button.classList.remove(
        'is-error'
      );

      button.innerHTML = 'ADD TO CART';

    }, 2000);

  }

}

/* =========================================================
   INIT
========================================================= */

document.addEventListener(
  'DOMContentLoaded',
  () => {

    document
      .querySelectorAll(
        '.complementary-products'
      )
      .forEach((container) => {

        new ComplementaryProducts(
          container
        );

      });

  }
);